import { CopyOnHover } from "@components/CopyOnHover"
import { useEffect, useState } from "react"

const loadVersion = async () => {
  let clientVersion = "not-set"
  try {
    clientVersion = await (await fetch("/version")).text()
    if (clientVersion.startsWith("<!DOCTYPE html")) clientVersion = "no version file"
  } catch (e) {
    clientVersion = "error fetching version"
  }
  let pgmVersion = "not-set"
  try {
    pgmVersion = (await (await fetch(`${import.meta.env.VITE_APP_API_URL}`)).json()).version
  } catch (e) {
    pgmVersion = "error fetching version"
  }
  let editorVersion = "not-set"
  try {
    editorVersion = (await (await fetch(`${import.meta.env.VITE_APP_EDITOR_URL}`)).json()).version
  } catch (e) {
    editorVersion = "error fetching version"
  }
  return { clientVersion, pgmVersion, editorVersion }
}

export const VersionDialog = () => {
  const [clientVersion, setClientVersion] = useState("not-set")
  const [pgmVersion, setPgmVersion] = useState("not-set")
  const [editorVersion, setEditorVersion] = useState("not-set")
  useEffect(() => {
    loadVersion().then(({ clientVersion, pgmVersion, editorVersion }) => {
      setClientVersion(clientVersion)
      setPgmVersion(pgmVersion)
      setEditorVersion(editorVersion)
    })
  }, [])
  return (
    <div>
      <b>Version</b>
      <br />
      <div style={{ paddingLeft: 15 }}>
        <b>client:</b> <CopyOnHover>{clientVersion}</CopyOnHover>
        <br />
        <b>pgm:</b> <CopyOnHover>{pgmVersion}</CopyOnHover>
        <br />
        <b>editor:</b> <CopyOnHover>{editorVersion}</CopyOnHover>
        <br />
      </div>
    </div>
  )
}
